import { EntityState } from '@ngrx/entity';

export interface ICountryState extends EntityState<any> {
  loading: boolean;
  loaded: boolean;
  currentCountry: { id: number, name: string, parentCodeCountry: string };
}
